export enum FORM_TYPE {
  PRE_QUALIFICATION = 'PRE_QUALIFICATION',
  BUSINESS_PLAN = 'BUSINESS_PLAN',
  PROJECT_SET_PORTFOLIO_BUSINESS_PLAN = 'PROJECT_SET_PORTFOLIO_BUSINESS_PLAN',
  CHECKLIST = 'CHECKLIST',
  PROJECT_APPLICATION = 'PROJECT_APPLICATION',
  MILESTONE_FORM = 'MILESTONE_FORM',
  ORGANIZATION = 'ORGANIZATION'
};
